import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { LogicEvents } from '@gongxigames/framework/slot/services/logic/LogicEvents';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { MultiSetsMulticampaignPromotionModule, MultiSetsMulticampaignPromotionStates } from '@gongxigames/framework/promotions';

export class MultiSetsMulticampaignPromotionBasicState extends ModuleState<
    null,
    MultiSetsMulticampaignPromotionModule,
    GlobalEventsMapForBackwardCompatibility
> {
    protected setupEvents(): void {
        this.setEventHandler('General.Flow.PAID_ROUND_ENDED', this.onPaidRoundEnded.bind(this));
        this.setEventHandler(LogicEvents.RESPONSE, this.onResponse.bind(this));
    }

    private onResponse(): void {
        if (this.module.getPromotion().hasPromotion() && this.module.nextActionIsSpin) {
            this.emit('General.Slot.SPIN.DISABLE', MultiSetsMulticampaignPromotionModule.NAME);
        }
    }
    private onPaidRoundEnded(): void {
        this.checkStartPromotion();
    }

    public onEnterState(): void {}
    public onLeaveState(): void {}

    private checkStartPromotion(): void {
        if (this.module.getPromotion().hasPromotion() && this.module.nextActionIsSpin) {
            this.module.gotoState(MultiSetsMulticampaignPromotionStates.START);
        }
    }
}
